import { defaultFirmaAbonnementerColumns } from "../../../../../config/firmaConfig";
import { firmaAbonnementerForm } from "../../../../../config/form/firma/firmaAbonnementerFormConfig";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import ActiveIcon from "../../../../icons/ActiveIcon";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../person/id/OpretNyButtonBlock";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import { FirmaDto } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import { orderBy } from "../../../../../util/orderBy";

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "navn1",
  },
];

export default function FirmaAbonnementer({
  firma,
  invalidateData,
}: {
  firma: FirmaDto;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "BasisWrite");
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "firmaAbonnementerSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );
  const [firmaAbonnementerColumns, setFirmaAbonnementerActiveColumns] =
    useActiveColumns(
      "firma-firmaabonnementer-active-columns",
      defaultFirmaAbonnementerColumns,
    );

  const { firmaAbonnement } = firma;

  if (firmaAbonnement?.length === 0) {
    return (
      <IngenRegistreringer
        invalidateData={invalidateData}
        editConfig={canWrite ? firmaAbonnementerForm(firma.id) : undefined}
      />
    );
  }

  // event handlers
  function downloadHandler() {
    if (firmaAbonnement?.length) {
      tableToXLSX(firmaAbonnementerColumns, firmaAbonnement, {
        fileName: `abonnementer-for-${firma.firmaNr}`,
        additionalData: {
          Firmanummer: firma.firmaNr,
        },
      });
    }
  }

  return (
    <ModalProvider>
      <ButtonDownload
        onClick={downloadHandler}
        isDisabled={!firmaAbonnement?.length}
      />
      <TableRoot>
        <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
          <>
            <th className="indicator"></th>
            {getHeaderActiveColumns(firmaAbonnementerColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        </TableHead>
        <TableBody>
          {orderBy(
            firmaAbonnement,
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((fa, i) => {
            return (
              <TableRow
                key={i}
                editConfig={
                  canWrite ? firmaAbonnementerForm(firma.id, fa.id) : undefined
                }
                invalidateData={invalidateData}
              >
                <td className="indicator">
                  <ActiveIcon />
                </td>
                <>
                  {firmaAbonnementerColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return <TD key={col.field} col={col} rowData={fa} />;
                    })}
                </>
              </TableRow>
            );
          })}
        </TableBody>
      </TableRoot>
      <ColumnEditorModal
        defaultColumns={defaultFirmaAbonnementerColumns}
        columns={firmaAbonnementerColumns}
        setActiveColumns={setFirmaAbonnementerActiveColumns}
      />
      <OpretNyButtonBlock
        invalidateData={invalidateData}
        editConfig={canWrite ? firmaAbonnementerForm(firma.id) : undefined}
      />
    </ModalProvider>
  );
}
